import React from "react";
import TicketsList from "../components/TicketsList/TicketsList";
import styles from "./page.default.module.css";
import { useTranslation } from "react-i18next";

const Tickets: React.FC = () => {
  const { t } = useTranslation();
  return (
    <section className={styles.pageSection}>
      <div className={styles.container}>
        <div className={styles.heading}>
          <h1 className={styles.title}>{t("ticketsList.title")}</h1>
          <p className={styles.description}>{t("ticketsList.description")}</p>
        </div>
        <TicketsList />
      </div>
    </section>
  );
};

export default Tickets;
